export default __webpack_public_path__ + "static/media/wf.de394ff1.svg";